import React from "react";
import { isValidArray } from "../../../helper";
import { NavLink } from "react-router-dom";

function SideBarMenuTemplate({
  options = [],
  headerTemplate,
  subMenuTemplate,
  containerClasses = ""
}) {
  return (
    <div className={containerClasses}>
      {options.map((value, index) => {
        return (
          <div>
            {headerTemplate ? (
              <>{headerTemplate({ ...value, index })}</>
            ) : (
              <NavLink {...value}>{value.title}</NavLink>
            )}
            {value.expandView && isValidArray(value.dropDown)
              ? value.dropDown.map(dropdownItem => {
                  // console.log(
                  //   { ...dropdownItem, index },
                  //   subMenuTemplate ? true : false,
                  //   "dropdownItem"
                  // );
                  return subMenuTemplate ? (
                    <>{subMenuTemplate({ ...dropdownItem, index })}</>
                  ) : (
                    <NavLink {...dropdownItem}>{dropdownItem.title}</NavLink>
                  );
                })
              : null}
          </div>
        );
      })}
    </div>
  );
}

export { SideBarMenuTemplate };
